import { useActor } from '@xstate/react';
import { ExpenseMachineActor } from '../../../machines/components/ExpenseMachine';
import { ExpenseView } from './ExpenseView';

export function ExpenseController({ actor }: { actor: ExpenseMachineActor }) {
  const [state, send] = useActor(actor);

  return <ExpenseView state={state} send={send} />;
}
